import React from "react";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const LoadingWidget = () => {
  return (
    <div
      style={{
        minWidth: "513px",
        minHeight: "389px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader type='ThreeDots' color='#0051BA' height={80} width={80} />
    </div>
  );
};

export default LoadingWidget;
